var BFFGatewayConfiguration = /** @class */ (function () {
    function BFFGatewayConfiguration(param) {
        this.accessToken = param.accessToken;
        this.locale = param.locale;
        this.basePath = param.basePath;
        this.blockId = param.blockId;
    }
    return BFFGatewayConfiguration;
}());
export { BFFGatewayConfiguration };
//# sourceMappingURL=BFFGatewayConfiguration.js.map